import Api from '@/services/Api';
import _ from 'lodash';
import MetodosGlobais from '@/utils/MetodosGlobais';

const RECURSO = '/licenciamentoDeEmpresas';



export default {
    logDados,
    licenciamentosPorSubConsolidado,
    empresasPorSubConsolidado,
    returnAtividades,
    licenciamentosPorSub,
    TMAPorAno,
    licenciamentosPorSubFechado,
    analiseViabilidadePorSubPorPeriodoFechado,
    analiseViabilidadePorSubPorIntervalo,
    analiseViabilidadeAberturaSolicitacaoPorIntervalo,
    analiseViabilidadeResultadoPorIntervalo,
    analiseViabilidadeEstabelecimentoPorIntervalo,
    ccmEmpresasEmpreendaFacilPorIntervalo,
    ccmEmpresasNoIntervalo
};

function logDados ({ agrupamento }) {
    return Promise.resolve()
    //return Api.get(`${RECURSO}/instituicoesDeEnsino${MetodosGlobais.createEncodeQuery(params)}`);
};


function licenciamentosPorSubConsolidado(){
    return Api.get(`${RECURSO}/licencas/consolidadoPorSubprefeitura`)
}

function empresasPorSubConsolidado(){
    return Api.get(`${RECURSO}/empresas/consolidadoPorSubprefeitura`)
}

function returnAtividades(){
    return Api.get(`${RECURSO}/licencas/consolidadoPorSecao`)
}

function licenciamentosPorSub({dataInicio, dataFim, agrupamento}){
    let params = { 'dataInicio': dataInicio, 'dataFim': dataFim, 'agrupamento': agrupamento};
    return Api.get(`${RECURSO}/licencas/porSubprefeituraPorPeriodo${MetodosGlobais.createEncodeQuery(params)}`);
}

function licenciamentosPorSubFechado({intervalo}){
    let params = { 'intervalo': intervalo};
    return Api.get(`${RECURSO}/licencas/porSubprefeituraPorPeriodoFechado${MetodosGlobais.createEncodeQuery(params)}`);
}

function TMAPorAno(){
    return Api.get(`${RECURSO}/licencas/tempoMedio/porAno`)
}

function analiseViabilidadePorSubPorPeriodoFechado({intervalo, agrupamento}){
    let params = {'intervalo': intervalo, 'agrupamento': agrupamento};
    return Api.get(`${RECURSO}/analiseViabilidade/porSubprefeituraPorPeriodoFechado${MetodosGlobais.createEncodeQuery(params)}`);
}

function analiseViabilidadePorSubPorIntervalo({dataInicio, dataFim, agrupamento}){
    let params = {'dataInicio': dataInicio, 'dataFim': dataFim, 'agrupamento': agrupamento};
    return Api.get(`${RECURSO}/analiseViabilidade/porSubprefeituraPorIntervalo${MetodosGlobais.createEncodeQuery(params)}`);
}

function analiseViabilidadeAberturaSolicitacaoPorIntervalo({dataInicio, dataFim, agrupamento}){
    let params = {'dataInicio': dataInicio, 'dataFim': dataFim, 'agrupamento': agrupamento};
    return Api.get(`${RECURSO}/analiseViabilidade/porAberturaSolicitacaoPorIntervalo${MetodosGlobais.createEncodeQuery(params)}`);
}

function analiseViabilidadeResultadoPorIntervalo({intervalo, agrupamento}){
    let params = {'intervalo': intervalo, 'agrupamento': agrupamento};
    return Api.get(`${RECURSO}/analiseViabilidade/resultadoPorIntervalo${MetodosGlobais.createEncodeQuery(params)}`);
}

function analiseViabilidadeEstabelecimentoPorIntervalo({intervalo}){
    let params = {'intervalo': intervalo};
    return Api.get(`${RECURSO}/analiseViabilidade/estabelecimentosPorIntervalo${MetodosGlobais.createEncodeQuery(params)}`);
}

function ccmEmpresasEmpreendaFacilPorIntervalo({intervalo}){
    let params = {'intervalo': intervalo};
    return Api.get(`${RECURSO}/ccm/empresasEmpreendaFacilPorIntervalo${MetodosGlobais.createEncodeQuery(params)}`);
}

function ccmEmpresasNoIntervalo({dataInicio, dataFim, filtrarEmpreenda, agrupamento}){
    let params = {'dataInicio': dataInicio, 'dataFim': dataFim, 'filtrarEmpreenda': filtrarEmpreenda,
                  'agrupamento': agrupamento};
    return Api.get(`${RECURSO}/ccm/empresasNoIntervalo${MetodosGlobais.createEncodeQuery(params)}`);
}
